import React from "react"
import * as S from "./styles"

interface Props {
  children?: string
  content?: string
  color?: string
  size?: string
  disabled?: boolean
  blank?: boolean
  onClick?: (event?: React.MouseEvent) => void
  type?: string
}

export default function Button(props: Props) {
  const {
    content,
    children = "",
    color = "primary",
    size = "default",
    blank = false,
    disabled = false,
    onClick,
    type = ""
  } = props

  return (
    <S.Button type={type} color={color} onClick={onClick} size={size} disabled={disabled} $blank={blank}>
      {content ?? children}
    </S.Button>
  )
}
